import { endOfDay, startOfDay } from 'date-fns'

import { LISTINGS_FILTER_PARAM } from '../../../../RentalPortalListing'

export const LISTINGS_FILTER_PARAM_LIST = Object.values(LISTINGS_FILTER_PARAM)

export const LISTINGS_TOGGLE_FILTER_PARAMS = [
  LISTINGS_FILTER_PARAM.needsMyAction,
]

export const LISTINGS_NUMBER_RANGE_FILTER_PARAMS = [
  [LISTINGS_FILTER_PARAM.rentPriceGte, LISTINGS_FILTER_PARAM.rentPriceLte],
]

export const LISTINGS_DEEP_LINK_DAY_BOUNDARY = {
  [LISTINGS_FILTER_PARAM.closedGte]: startOfDay,
  [LISTINGS_FILTER_PARAM.closedLte]: endOfDay,
  [LISTINGS_FILTER_PARAM.createdGte]: startOfDay,
  [LISTINGS_FILTER_PARAM.createdLte]: endOfDay,
  [LISTINGS_FILTER_PARAM.firstPublishedAtGte]: startOfDay,
  [LISTINGS_FILTER_PARAM.firstPublishedAtLte]: endOfDay,
  [LISTINGS_FILTER_PARAM.scheduledDeactivateGte]: startOfDay,
  [LISTINGS_FILTER_PARAM.scheduledDeactivateLte]: endOfDay,
  [LISTINGS_FILTER_PARAM.scheduledGoLiveGte]: startOfDay,
  [LISTINGS_FILTER_PARAM.scheduledGoLiveLte]: endOfDay,
  [LISTINGS_FILTER_PARAM.updatedGte]: startOfDay,
  [LISTINGS_FILTER_PARAM.updatedLte]: endOfDay,
}

export const LISTINGS_BOARD_PAGE_SIZE = 50
